import React from "react";
import { Redirect } from "react-router";
import LoadingModal from "src/modes/Electric/LoadingModal";
import useSelector from "src/utils/useSelector";

export default function UnlockedPricingDefaultRoute() {
    const isAuthed = useSelector((state) => state.onlineShopper.isAuthed);
    const hasDeal = useSelector((state) => state.deal.uuid !== undefined);
    const hasVehicles = useSelector((state) => !!state.vehicles.order.length);
    const openToTradeIn = useSelector((state) => state.onlineShopper.tradeInOpen);

    if (!hasDeal || !hasVehicles) {
        return <LoadingModal />;
    }

    if (openToTradeIn) {
        return <Redirect to="/payment-builder/trade-in" />;
    }

    if (isAuthed) {
        return <Redirect to="/my-garage" />;
    }

    return <Redirect to="/payment-builder" />;
}
